import { render, staticRenderFns } from "./edit-package.vue?vue&type=template&id=7be7cecc&"
import script from "./edit-package.vue?vue&type=script&lang=js&"
export * from "./edit-package.vue?vue&type=script&lang=js&"
import style0 from "./edit-package.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports